module.exports = __webpack_public_path__ + "img/qddk-back.87c1bd3a.png";